/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from "react";

export default function FAQ() {
  return (
    <div>
      <h2 className="helpHeaderTitle">Frequently Asked Questions </h2>
      <div className="helpContentSection">
        <div className="questionAnsWrapper">
          <div className="questionRow boldTitle">
            <p className="questionSection">Q:</p>
            <p className="answerSection">
              How should I order content in the campaign?
            </p>
          </div>
          <div className="questionRow ">
            <p className="questionSection">A.</p>
            <p className="answerSection">
              We suggest that content be variable. Static graphics, videos, and
              advertisements should be spread evenly throughout so there aren’t
              3 advertisements back-to-back (unless by design) and that if there
              are 10 static and 10 videos, they should be ordered as Video 1,
              Static 1, Video 2, Static 2 etc.
            </p>
          </div>
        </div>
        <div className="questionAnsWrapper">
          <div className="questionRow boldTitle">
            <p className="questionSection">Q:</p>
            <p className="answerSection">
              Can I deploy a calendar when the calendar event has already
              occurred?
            </p>
          </div>
          <div className="questionRow ">
            <p className="questionSection">A.</p>
            <p className="answerSection">
              Yes, if it is on the day of the event the calendar can be set to
              start at a past time and go until the desired stop time.
            </p>
          </div>
        </div>
        <div className="questionAnsWrapper">
          <div className="questionRow boldTitle">
            <p className="questionSection">Q:</p>
            <p className="answerSection">
              What time zone should be used when creating calendar events?
            </p>
          </div>
          <div className="questionRow ">
            <p className="questionSection">A.</p>
            <p className="answerSection">
              The calendar will automatically be set to the time zone of the
              player it’s being pushed to - so if you set a calendar event to
              play from 4pm - 11pm and send to a device in EST, content will
              play from 4pm - 11pm EST.
            </p>
          </div>
        </div>
        <div className="questionAnsWrapper">
          <div className="questionRow boldTitle">
            <p className="questionSection">Q:</p>
            <p className="answerSection">What file types are supported?</p>
          </div>
          <div className="questionRow ">
            <p className="questionSection">A.</p>
            <p className="answerSection">
              For videos, .mp4 and for images, .png and .jpg
            </p>
          </div>
        </div>
        <div className="questionAnsWrapper">
          <div className="questionRow boldTitle">
            <p className="questionSection">Q:</p>
            <p className="answerSection">
              Should I push a campaign or calendar to screens?
            </p>
          </div>
          <div className="questionRow ">
            <p className="questionSection">A.</p>
            <p className="answerSection">
              Campaigns play continuously, so if there is a desired stop time a
              calendar makes more sense.
            </p>
          </div>
        </div>
        <div>
          <div className="questionRow boldTitle">
            <p className="questionSection">Q:</p>
            <p className="answerSection">
              How do I know which campaign to send to the screens?
            </p>
          </div>
          <div className="questionRow ">
            <p className="questionSection">A.</p>
            <p className="answerSection">
              Each campaign name is formatted to [TeamCityName_Homestand
              Number_FormFactor]. Search for team city name, and the results
              will show the most recently used campaign which should also have
              the highest number homestand - this campaign will be what needs to
              be pushed. Bear in mind select ballparks will have campaigns with
              audio / without audio as well as off-events such as soccer loops.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
